import React from 'react';
import { Button, useDisclosure } from "@heroui/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import UserGuideModal from './components/UserGuideModal';

const UserGuide: React.FC = () => {

    const [visible, setVisible] = React.useState(false);
    const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();

    const handleOnClick = () => {
        setVisible(true);
        onOpen();
    };

    return (
        <>
            <Button 
                size='sm' 
                className="bg-msi-chart-orange text-white rounded mr-2"
                onPress={handleOnClick}
                startContent={<FontAwesomeIcon icon={faVideo} className="text-sm" />}
            >
                User Guide
            </Button>
            {visible && <UserGuideModal
                isOpen={isOpen} 
                onOpenChange={onOpenChange} 
                onClose={onClose} 
            />}
        </>
    );
};

export default UserGuide;